/* tslint:disable */
/* eslint-disable */
/**
 * Melco Assets APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AssetsMelcoModelsColorARGB,
    AssetsMelcoModelsColorARGBFromJSON,
    AssetsMelcoModelsColorARGBFromJSONTyped,
    AssetsMelcoModelsColorARGBToJSON,
} from './';

/**
 * 
 * @export
 * @interface AssetsMelcoModelsThreadChartColor
 */
export interface AssetsMelcoModelsThreadChartColor {
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsThreadChartColor
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsThreadChartColor
     */
    code?: string | null;
    /**
     * 
     * @type {AssetsMelcoModelsColorARGB}
     * @memberof AssetsMelcoModelsThreadChartColor
     */
    color?: AssetsMelcoModelsColorARGB;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsThreadChartColor
     */
    type?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssetsMelcoModelsThreadChartColor
     */
    weight_list?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsThreadChartColor
     */
    supplier_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsThreadChartColor
     */
    supplier_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsThreadChartColor
     */
    product_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetsMelcoModelsThreadChartColor
     */
    product_name?: string | null;
}

export function AssetsMelcoModelsThreadChartColorFromJSON(json: any): AssetsMelcoModelsThreadChartColor {
    return AssetsMelcoModelsThreadChartColorFromJSONTyped(json, false);
}

export function AssetsMelcoModelsThreadChartColorFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetsMelcoModelsThreadChartColor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'color': !exists(json, 'color') ? undefined : AssetsMelcoModelsColorARGBFromJSON(json['color']),
        'type': !exists(json, 'type') ? undefined : json['type'],
        'weight_list': !exists(json, 'weight_list') ? undefined : json['weight_list'],
        'supplier_id': !exists(json, 'supplier_id') ? undefined : json['supplier_id'],
        'supplier_name': !exists(json, 'supplier_name') ? undefined : json['supplier_name'],
        'product_id': !exists(json, 'product_id') ? undefined : json['product_id'],
        'product_name': !exists(json, 'product_name') ? undefined : json['product_name'],
    };
}

export function AssetsMelcoModelsThreadChartColorToJSON(value?: AssetsMelcoModelsThreadChartColor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'code': value.code,
        'color': AssetsMelcoModelsColorARGBToJSON(value.color),
        'type': value.type,
        'weight_list': value.weight_list,
        'supplier_id': value.supplier_id,
        'supplier_name': value.supplier_name,
        'product_id': value.product_id,
        'product_name': value.product_name,
    };
}


